import clsx from 'clsx';
import React from 'react';

const LayoutLine = (props: { className?: string }) => (
  <hr className={clsx('tw-my-4 tw-border-layout-line-light dark:tw-border-layout-line-dark', props.className)} />
);

export default LayoutLine;
